// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_bc {
    height: 100vh;
    background-color: #006633;
}

.main_logo{
    position: absolute;
    top:30px;
    left: 30px;
    -webkit-user-select: none;
            user-select: none;
}
.container_logo {
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-user-select: none;
            user-select: none;
    height: 100vh;
    pointer-events: none;
    /* 使容器的高度为视口高度，可根据需要调整 */
}

.Login_form {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.login-container {
    width: 350px;
    border: 1px solid #eaeaea;
    margin: 180px auto;
    padding: 35px 35px 15px 35px;
    background-color: #fff;
    /* border-radius: 15px; */
    box-sizing: border-box;
    -webkit-user-select: none;
            user-select: none;

}

.login-container .login_title {
    text-align: center;
    margin-bottom: 40px;
    color: #006633;
    font-size: 20px;
    
}

.login-container .el-input {
    width: 198px;
}

.login-container .login-button {
    text-align: center;
}
.Login_button{
    width: 100%;
    border-radius: 90px;
    background-color:  #006633;
}
.ant-form-item .ant-form-item-label{
    width: 40px;
}`, "",{"version":3,"sources":["webpack://./src/pages/login/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,yBAAiB;YAAjB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;IACjB,aAAa;IACb,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,4BAA4B;IAC5B,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,yBAAiB;YAAjB,iBAAiB;;AAErB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;;AAEnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,0BAA0B;AAC9B;AACA;IACI,WAAW;AACf","sourcesContent":[".Login_bc {\r\n    height: 100vh;\r\n    background-color: #006633;\r\n}\r\n\r\n.main_logo{\r\n    position: absolute;\r\n    top:30px;\r\n    left: 30px;\r\n    user-select: none;\r\n}\r\n.container_logo {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    user-select: none;\r\n    height: 100vh;\r\n    pointer-events: none;\r\n    /* 使容器的高度为视口高度，可根据需要调整 */\r\n}\r\n\r\n.Login_form {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh;\r\n}\r\n\r\n.login-container {\r\n    width: 350px;\r\n    border: 1px solid #eaeaea;\r\n    margin: 180px auto;\r\n    padding: 35px 35px 15px 35px;\r\n    background-color: #fff;\r\n    /* border-radius: 15px; */\r\n    box-sizing: border-box;\r\n    user-select: none;\r\n\r\n}\r\n\r\n.login-container .login_title {\r\n    text-align: center;\r\n    margin-bottom: 40px;\r\n    color: #006633;\r\n    font-size: 20px;\r\n    \r\n}\r\n\r\n.login-container .el-input {\r\n    width: 198px;\r\n}\r\n\r\n.login-container .login-button {\r\n    text-align: center;\r\n}\r\n.Login_button{\r\n    width: 100%;\r\n    border-radius: 90px;\r\n    background-color:  #006633;\r\n}\r\n.ant-form-item .ant-form-item-label{\r\n    width: 40px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
